import {
  SelectedFilters,
  useCampaignStore,
} from '@lidea/shared/data-access/core';
import { useInfiniteQuery } from '@tanstack/react-query';

import { plotKeys } from './../../keys/plot-keys';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UseInfinitePlotsProps {
  selectedFilters: SelectedFilters;
  enabled?: boolean;
}

export function useInfinitePlots(props: UseInfinitePlotsProps) {
  const campaignId = useCampaignStore((s) => s.campaignId);

  const infiniteQuery = useInfiniteQuery({
    ...plotKeys.search(props.selectedFilters, campaignId),
    enabled: props.enabled !== false && !!campaignId,
  });

  return infiniteQuery;
}

export default useInfinitePlots;
